import React, { memo, lazy, Suspense } from 'react';
import { WeatherTrafficViewTypes, CameraViewTypes } from './weatherTrafficViewTypes';
import { WeatherTrafficCamLoadingUI } from './weatherTrafficCamLoadingUI';

const WeatherCamsLandingPageView = lazy(() => import('../weatherTrafficCamsPages/weatherCamsLandingPageView/weatherCamsLandingPageView'));
const TrafficCamsLandingPageView = lazy(() => import('../weatherTrafficCamsPages/trafficCamsLandingPageView/trafficCamsLandingPageView'));
const WeatherCategoryCamsLandingPageView = lazy(() => import('../weatherTrafficCamsPages/weatherCategoryCamsLandingPageView/weatherCategoryCamsLandingPageView'));
const WeatherCameraDetailPageView = lazy(() => import('../weatherTrafficCamsPages/cameraDetailPage/weatherCameraDetail/weatherCameraDetailPageView'));
const TrafficCameraDetailPageView = lazy(() => import('../weatherTrafficCamsPages/cameraDetailPage/trafficCameraDetail/trafficCameraDetailPageView'));

interface DisplayCameraUIProps {
    camViewType: CameraViewTypes;
}

export const DisplayCameraUI = memo((
    {
        camViewType
    }: DisplayCameraUIProps
) => {

    switch (camViewType) {
        case WeatherTrafficViewTypes.weatherCamLandingPage:
        {
            
            return (
                <Suspense fallback={<WeatherTrafficCamLoadingUI/>}>
                    <WeatherCamsLandingPageView />
                </Suspense>
            );
        }
        case WeatherTrafficViewTypes.trafficCamLandingPage:
        {
            return (
                <Suspense fallback={<WeatherTrafficCamLoadingUI/>}>
                    <TrafficCamsLandingPageView />
                </Suspense>
            );
        }
        case WeatherTrafficViewTypes.weatherCamCategoryPage:
        {
            return (
                <Suspense fallback={<div>Loading...</div>}>
                    <WeatherCategoryCamsLandingPageView />
                </Suspense>
            );
        }
        case WeatherTrafficViewTypes.weatherCamDetailPage:
        {
            return (
                <Suspense fallback={<WeatherTrafficCamLoadingUI isDetailPage={true} />}>
                    <WeatherCameraDetailPageView />
                </Suspense>
            );
        }
        case WeatherTrafficViewTypes.trafficCamDetailPage:
        {
            return (
                <Suspense fallback={<WeatherTrafficCamLoadingUI isDetailPage={true} isTrafficDetailPage={true} />}>
                    <TrafficCameraDetailPageView />
                </Suspense>
            );
        }
        default: 
        {
            return (
                <Suspense fallback={<div>Loading...</div>}>
                    <WeatherCamsLandingPageView />
                </Suspense>
            );
        }
    }
});

DisplayCameraUI.displayName = 'DisplayCameraUI';